import { ReactComponent as BallIcon } from 'images/Icons/Ball.svg';
import { ReactComponent as DiamondIcon } from 'images/Icons/Diamond.svg';
import { ReactComponent as SlotsIcon } from 'images/Icons/Slots.svg';

export const GAME_TYPE_OPTIONS = [
  {
    label: 'All games',
    value: '',
    Icon: DiamondIcon,
  },
  {
    label: 'Slot games',
    value: 'Video Slot',
    Icon: SlotsIcon,
  },
  {
    label: 'Instant games',
    value: 'Instant Game',
    Icon: BallIcon,
  },
];

export const COUNTRIES = [
  'Malta',
  'Bulgaria',
  'Croatia',
  'Lithuania',
  'Italy',
  'Portugal',
  'Romania',
  'Peru',
  'Brazil',
  'Czech Republic',
  'Ontario',
];

export const GAME_NAME_COLUMN_ID = 'gameName';
export const ALL_GAMES_ROW_ID = 'allGames';

export const COLUMNS = [
  {
    id: GAME_NAME_COLUMN_ID,
    label: 'Game name',
    width: '250px',
  },
  {
    id: 'Malta',
    label: 'Malta',
  },
  {
    id: 'Bulgaria',
    label: 'Bulgaria',
  },
  {
    id: 'Croatia',
    label: 'Croatia',
  },
  {
    id: 'Lithuania',
    label: 'Lithuania',
  },
  {
    id: 'Italy',
    label: 'Italy',
  },
  {
    id: 'Portugal',
    label: 'Portugal',
  },
  {
    id: 'Romania',
    label: 'Romania',
  },
  {
    id: 'Peru',
    label: 'Peru',
  },
  {
    id: 'Brazil',
    label: 'Brazil',
  },
  {
    id: 'Czech Republic',
    label: 'Czech Rep.',
  },
  {
    id: 'Ontario',
    label: 'Ontario',
  },
];
